var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      staticClass: "current-select",
      attrs: {
        filterable: "",
        remote: "",
        clearable: "",
        "remote-method": _vm.handleRemote,
        placeholder: _vm.$t("CargoMsg.Cargo_PleaseSelect")
      },
      on: { change: _vm.changeHandle },
      model: {
        value: _vm.selectedValue,
        callback: function($$v) {
          _vm.selectedValue = $$v
        },
        expression: "selectedValue"
      }
    },
    _vm._l(_vm.options, function(item) {
      return _c("el-option", {
        key: item.uuid,
        attrs: { label: item.code + item.city, value: item.uuid }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }